export enum DeliveryStartTypes {
  DesiredDate = 'desired_date',
  EarliestPossibleDate = 'earliest_possible_date',
  TerminatedInPerson = 'terminated_in_person',
  RelocationAt = 'relocation_at',
  BasicSupply = 'basic_supply'
}
